import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getRotateQuestions } from '../../../api/rotate-questions';

export const getRotateQuestionsAsync = createAsyncThunk(
  'rotateQuestions/getRotateQuestions',
  getRotateQuestions
);

export interface RotateQuestion {
  id: number;
  name: string;
  isRequired: boolean;
  isMultiple: boolean;
  rotateAnswers: {
    id: number;
    name: string;
    hideForEquipmentListRelations: {
      rotateEquipmentListId: number;
    }[]; // Hide the answer if this equipment list was selected
  }[];
  hideForEquipmentListRelations: {
    rotateEquipmentListId: number;
  }[]; // Hide the question if this equipment list was selected
  hideForEquipmentListAnswerRelations: {
    rotateEquipmentListId: number;
    rotateAnswerId: number;
  }[]; // Hide the question if this equipment list and answer were selected
}

interface RotateQuestionState {
  data: RotateQuestion[];
}

const initialState: RotateQuestionState = {
  data: []
};

export default createSlice({
  name: 'rotateQuestions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRotateQuestionsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
  }
});
